import { PopOutController } from "../../shared/popOutController";
import { ResponsiveState } from "../../shared/responsiveState";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { StringEnums } from "../../shared/utilities/enums/stringEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { ICarouselGallery } from "./carouselGallery";
import { PagingCarouselGallery } from "./pagingCarouselGallery";

export interface IPopOutCarouselGallery extends ICarouselGallery {

}
export class PopOutCarouselGallery extends PagingCarouselGallery implements IPopOutCarouselGallery {
    private readonly _closePopOut;
    constructor(public htmlElement: Element, topLevelHtmlElement?: HTMLElement) {
        super(htmlElement, UtilityEnums.ComponentOrientation.Horizontal, UtilityEnums.ComponentOrientation.Horizontal, topLevelHtmlElement);
        this._closePopOut = this.closePopOut.bind(this);
        this.addCssClasses(AttributeEnums.PopOutCarouselGallery.singlePagingHorizontal, AttributeEnums.PopOutCarouselGallery.pagingSelectableHorizontal);
        this.attachPopOutCarouselGalleryCloseClickEventListener();
    }

    addCssClasses(singlePaging: string, pagingSelectable: string): void {
        console.log(`PopOutCarouselGallery: addCssClasses ${singlePaging}`);
        this.htmlElement.classList.add(singlePaging);
        this.htmlElement.classList.add(pagingSelectable);
    }

    setPagingSelectableCarouselByOrientation(): string {
        console.log(`PopOutCarouselGallery: setPagingSelectableCarouselByOrientation`);
        return UtilityEnums.ComponentOrientation.Horizontal;
    }

    attachPopOutCarouselGalleryCloseClickEventListener(): void {
        console.log('PopOutCarouselGallery: attachPopOutCarouselGalleryCloseClickEventListener');
        let closeButtonHtmlElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PopOutCarouselGallery.Close));
        closeButtonHtmlElement.addEventListener('click', this._closePopOut);
    }

    removePopOutCarouselGalleryCloseClickEventListener(): void {
        console.log('PopOutCarouselGallery: removePopOutCarouselGalleryCloseClickEventListener');
        let closeButtonHtmlElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PopOutCarouselGallery.Close));
        closeButtonHtmlElement.removeEventListener('click', this._closePopOut);
    }

    closePopOut() {
        console.log('PopOutCarouselGallery: closePopOut');
        ((<any>window).popOutController as PopOutController).closeAllMenus();

        this.unsetpopOutGalleryZIndex();
    }

    unsetpopOutGalleryZIndex(): void {
        let popOutGalleryParent: HTMLElement = this.htmlElement.closest(HelperUtils.addCssClassDot(StringEnums.CssClass.LbProductPageLayoutGallery));
        popOutGalleryParent.style.zIndex = 'unset';
    };

    dispose(): void {
        this.removePopOutCarouselGalleryCloseClickEventListener();
        super.dispose();
    }
}